// extracted by mini-css-extract-plugin
module.exports = {"about":"WhoWeAre_about__1fYaO","logo":"WhoWeAre_logo__PM_6v","articlesWrapper":"WhoWeAre_articlesWrapper__12U9C","mission":"WhoWeAre_mission__AFt-N","who":"WhoWeAre_who__3U7Gi"};